//constFactory() could be used to create trueFn, falseFn, etc..
//but they are hand written to eliminate unnecessary closure to `constant`
export const constFactory =
  <T>(constant: T) =>
  (): T =>
    constant;

export const trueFn = (): true => true;
export const falseFn = (): false => false;
export const nullFn = (): null => null;
export const undefinedFn = (): undefined => undefined;

export const truePromise = Promise.resolve<true>(true);
export const falsePromise = Promise.resolve<false>(false);
export const nullPromise = Promise.resolve<null>(null);
export const undefinedPromise = Promise.resolve<undefined>(undefined);

export const truePromiseFn = (): Promise<true> => truePromise;
export const falsePromiseFn = (): Promise<false> => falsePromise;
export const nullPromiseFn = (): Promise<null> => nullPromise;
export const undefinedPromiseFn = (): Promise<undefined> => undefinedPromise;
